import axios from "axios";
import * as actionType from "../../constant/actionType";
export const GetAllClientsOfProviderList = (apiData) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const params = Object.fromEntries(
        Object.entries(apiData || {}).filter(
          ([, value]) => value !== undefined && value !== null && value !== ""
        )
      );
      const response = await axios({
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
        },
        url: `${actionType.environment_url}/api/admin/provider/GetAllClientsOfProviderList`,
        params
      });
      return response.data
      
    } catch (error) {
        return error.message  
    }
  };